export enum TransportMode {
  unknown = 'unknown',
  none = 'none',
  tram = 'tram',
  bus = 'bus',
  ferry = 'ferry',
  train = 'train',
  taxi = 'taxi',
  walk = 'walk',
  bike = 'bike',
  car = 'car',
  // NV-5212 - Buss on demand should be removed when trial period is over
  bussondemand = 'teletaxi',
}
